// Auto-generated translation for fi.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:15:23.642921+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Hevosenomistajille",
    title: "Kaikki hevosellesi. Yhdessä sovelluksessa.",
    subtitle: "Hallitse terveyttä, harjoittelua, aikatauluja ja ammattilaisia yhdestä selkeästä kansiosta.",
    primaryCTA: {
      label: "Aloita ilmaiseksi",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Katso Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Hevosprofiili — paino, rokotukset, EquiCoach, ravitsemus ja harjoittelu yhdellä näytöllä",
      caption: "Hevosesi, täydellisesti näkyvillä.",
    },
    problem: "Pidät todennäköisesti tapaamisia, kuvia, harjoittelua, ravitsemusta ja terveystietoja hajallaan — WhatsApp-ryhmissä, kenkälaatikoissa ja erillisissä sovelluksissa. Tämän takia kokonaiskuva jää puuttumaan.",
    solution: "EquiSight tekee hevosestasi yhden täydellisen digitaalisen kansion, joka kulkee mukanasi.",
    benefits: [
      "Yksi kattava hevosprofiili per hevonen",
      "Terveys, kaviontrimmaaja, hevoshammasteknikko ja fysioterapeutti yhdessä paikassa",
      "Kalenteri älykkäillä muistutuksilla",
      "Kuvat, muistiinpanot ja historia ilman rajoituksia",
      "Varmuuskopio kaikesta datastasi Premium-tilauksella",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 hevonen · aina ilmainen",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Useampi hevonen + varmuuskopio",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis aloittamaan?",
      title: "Aloita tänään ensimmäisellä hevosellasi.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Enemmän hevosia. Enemmän hallintaa. Enemmän varmuutta.",
    subtitle: "Päivitä Premiumiin ja hallitse kaikkia hevosiasi ilman rajoituksia — täydellä EquiCoach-älykkyydellä.",
    primaryCTA: {
      label: "Aloita 14 päivän ilmainen kokeilu",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Kaikki hinnat",
      href: "/#pricing",
    },
    audience: "Omistajille, kilparatsastajille ja hevosenpitäjille, joilla on useita hevosia.",
    features: [
      "Lisää hevosia rajattomasti",
      "Täydellinen historia hevoskohtaisesti",
      "Tietojen varmuuskopiointi",
      "Laajat EquiCoach-näkemykset",
      "Älykkäät ilmoitukset ja suunnittelu",
      "Terveys ja harjoittelu täysin yhdistettynä",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Alle €0,17 päivässä",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Päivitä Premiumiin.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Maneesin ratsastajille",
    title: "Kehity paremmaksi, vaikka sinulla ei olisi omaa hevosta.",
    subtitle: "Seuraa tuntejasi, harjoituksiasi ja kehitystäsi EquiSightissa — alle kahvikupin hintaan kuukaudessa äidille tai isälle. Tai yhden herkullisen jäätelön hinnalla kermavaahdolla.",
    primaryCTA: {
      label: "Aloita Premiumilla",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Miten se toimii?",
      href: "#features",
    },
    problem: "Maneesin ratsastajana sinulla ei usein ole omaa hevosta, mutta haluat silti kehittyä ja pitää kirjaa tunneistasi, tavoitteistasi ja hevosista, joilla ratsastat.",
    solution: "Maneesin toiminnallisuus sisältyy vakiona Premiumiin — seuraa omaa kehitystäsi ja tarkastele liitettyjä maneesin hevosia vain luku -tilassa.",
    features: [
      "Harjoitusten seuranta",
      "Tavoitteiden asettaminen",
      "Edistymisen seuranta",
      "Maneesin hevosten tarkastelu nimellä ja kuvalla",
      "Ei pääsyä yksityisiin terveystietoihin",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Kuukaudessa · maneesin toiminnallisuus sisältyy hintaan",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Liity jäseneksi",
      title: "Aloita maneesin ratsastajana.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Maneeseihin ja talleihin",
    title: "Tee maneesistasi digitaalisesti saavutettava jokaiselle ratsastajalle.",
    subtitle: "Anna ratsastajille yhteys hevosiin, tunteihin ja edistymiseen — jakamatta arkaluonteisia tallidatoja.",
    primaryCTA: {
      label: "Pyydä käyttöoikeutta",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Katso moduulit",
      href: "#features",
    },
    audience: "EquiSight auttaa maneeseja ja talleja pitämään ratsastajat sitoutuneempina ja erottumaan digitaalisesti.",
    features: [
      "Maneesihevosten näkyvyys ratsastajille",
      "Nimi ja kuva jokaiselle hevoselle",
      "Ratsastajien yhdistäminen hevosiin",
      "Vain luku -oikeus yksityisyysarkaluonteiseen dataan",
      "Tunti- ja harjoitushistoria keskitetysti",
      "Käyttäjähallinta rooleilla",
    ],
    benefits: [
      "Vahvempi side ratsastajiin",
      "Ammattimaisempi ulkoasu",
      "Lisädigitaalinen palvelu jäsenille",
      "Uusi tulovirta sovelluksen käytön kautta",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Kuukaudessa · maneesitoiminnallisuus sisältyy ratsastajille",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Aktivoi Maneesimoduuli.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Jalostusmoduuli",
    title: "Hallitse kiimakiertoa, tiineyttä ja varsan kehitystä.",
    subtitle: "Täydellinen jalostusmoduuli tammanomistajille ja kasvattajille — astutuksesta varsaan, yhdellä aikajanalla.",
    primaryCTA: {
      label: "Aktivoi jalostusmoduuli",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Katso ominaisuudet",
      href: "#features",
    },
    audience: "Kasvattajille, tammanomistajille ja talleille, jotka hoitavat useita tammoja.",
    features: [
      "Kiimakierron seuranta",
      "Kiimaisuuden kirjaaminen",
      "Siemennyspäivämäärien tallentaminen",
      "Lähtölaskenta kaikuihin",
      "Tiineystarkastusten suunnittelu",
      "Sukupuu ja polveutuminen",
      "Varsan kehitys",
      "Kaikkien tiineiden tammojen yleiskatsaus",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Kuukaudessa · Jalostusmoduuli sisältyy Pro-pakettiin",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Aloita tänään",
      title: "Aloita jalostuksen hallinta.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Kengitysseppä-moduuli",
    title: "Työskentele älykkäämmin kengitysseppänä. Kirjaa kaikki ammattimaisesti.",
    subtitle: "Kalenteri, valokuvat, huomiot ja hoitohistoria yhdessä moduulissa — vähemmän väärinkäsityksiä, vahvempi dokumentaatio.",
    primaryCTA: {
      label: "Aloita kengitysseppänä",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Katso Professional-paketti",
      href: "/professional",
    },
    audience: "Kengityssepille, jotka haluavat parantaa yleiskatsausta, dokumentointia ja asiakasviestintää.",
    features: [
      "Oma kalenteri",
      "Tapaamiset asiakkaittain",
      "Hevosprofiilien tarkastelu",
      "Ennen ja jälkeen -kuvien lisääminen",
      "Hoitotoimenpiteen kirjaaminen",
      "Neuvojen ja huomioiden tallentaminen",
      "ETA-ilmoitus asiakkaalle: \"Kengitysseppä on matkalla\"",
    ],
    benefits: [
      "Ammattimaisempi työskentely",
      "Vähemmän väärinkäsityksiä",
      "Parempi dokumentaation rakentaminen",
      "Vahvempi vastuukysymyksissä",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Kuukaudessa · Kengitysseppä-moduuli sisältyy Professional-pakettiin",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Aktivoi Kengitysseppä-moduuli.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Hammaslääkärimoduuli",
    title: "Täydellinen hammashuoltorekisteri hevosta kohden.",
    subtitle: "Kirjaa löydökset, hoidot ja seuranta suoraan EquiSightiin.",
    primaryCTA: {
      label: "Aloita hevoshammaslääkärinä",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Katso Professional-paketti",
      href: "/professional",
    },
    audience: "Hevoshammaslääkäreille, eläinlääkäreille ja vastaanotoille, jotka haluavat työskennellä järjestelmällisesti.",
    features: [
      "Hammastarkastuksen kirjaaminen",
      "Löydökset hoitoa kohden",
      "Kuvien lisääminen",
      "Raportointi omistajalle",
      "Seurantasuositus",
      "Historia hevosta kohden",
      "Uuden tapaamisen suunnittelu",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Kuukaudessa · Hammaslääkärimoduuli sisältyy Professional-pakettiin",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Aktivoi hammaslääkärimoduuli.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Fysio / Osteo -moduuli",
    title: "Seuraa kehoa, liikettä ja toipumista ammattimaisesti.",
    subtitle: "Fysioterapeuteille ja osteopaateille, jotka haluavat ohjata hevosia järjestelmällisesti.",
    primaryCTA: {
      label: "Aloita fysiona/osteopaattina",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Katso Professional-paketti",
      href: "/professional",
    },
    features: [
      "Hevoskohtainen alkukartoitus",
      "Kehon löydösten kirjaaminen",
      "Kuvien ja videoiden lisääminen",
      "Hoitoraportin luominen",
      "Harjoitusten ja seurannan jakaminen",
      "Toipumispolun seuranta",
      "Hevoskohtainen historia",
    ],
    benefits: [
      "Parempi kokonaiskuva ajan myötä",
      "Ammattimainen raportointi",
      "Selkeä viestintä omistajan, valmentajan ja ratsastajan kanssa",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per kuukausi · Fysio / Osteo -moduuli sisältyy Professional-pakettiin",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Aktivoi Fysio / Osteo -moduuli.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Valmentajamoduuli",
    title: "Valmennat ratsastajia datan, tavoitteiden ja edistymisen avulla.",
    subtitle: "Tee harjoittelusta mitattavaa ja valmennuksesta ammattimaisempaa — yhdelle tai useammalle ratsastajalle.",
    primaryCTA: {
      label: "Aloita valmentajana",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Katso Pro-paketti",
      href: "/#pricing",
    },
    audience: "Instruktoreille, valmentajille ja coaches-ammattilaisille, joilla on useita ratsastajia tai hevosia.",
    features: [
      "Yhdistä ratsastajia",
      "Seuraa hevosia",
      "Aseta harjoitustavoitteet",
      "Anna palautetta",
      "Analysoi kilpailutuloksia",
      "Tarkastele edistymistä yhdistelmäkohtaisesti",
      "Käytä protokolla-analyysejä harjoittelun fokusointiin",
    ],
    benefits: [
      "Parempi valmennus",
      "Enemmän rakennetta",
      "Ammattimaisempi viestintä",
      "Vahvempi asiakassuhde",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Kuukausittain · Valmentajamoduuli sisältyy Pro-pakettiin",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Aktivoi valmentajamoduuli.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Kilpailuanalyysi",
    title: "Pöytäkirjasta suorituksen parantamiseen.",
    subtitle: "Lataa kilpailupöytäkirjasi ja selvitä, mistä pisteet jäävät saamatta — älä vain katso tulostasi, vaan ymmärrä, miten kehityt.",
    primaryCTA: {
      label: "Analysoi ensimmäinen pöytäkirjasi",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Tutustu Premiumiin",
      href: "/premium",
    },
    features: [
      "Pöytäkirjan kuvan lataaminen",
      "Etu- ja takapuolen käsittely",
      "Luokan, tehtävänumeron ja tuomarin tunnistaminen",
      "Pisteiden analysointi osa-alueittain",
      "Kommenttien yhteenveto",
      "Vahvuuksien ja heikkouksien näyttäminen",
      "Trendit hevonen–ratsastaja-yhdistelmittäin",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Kuukaudessa · kilpailuanalyysi sisältyy Premiumista alkaen",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Aloita kilpailuanalyysi.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional-paketti",
    title: "Hevosammattilaisille suunniteltu.",
    subtitle: "Kaviontrimmaaja, hammaslääkäri, fysioterapeutti, osteopaatti tai valmentaja: työskentele yhdessä digitaalisessa hevostiedostossa.",
    primaryCTA: {
      label: "Aloita ammattilaisena",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Katso yksittäiset moduulit",
      href: "#features",
    },
    audience: "Professional-paketti yhdistää kaikki ammattimoduulit yhteen tilaukseen.",
    features: [
      "Kaviontrimmaajan moduuli",
      "Hammaslääkärin moduuli",
      "Fysio / Osteopatia -moduuli",
      "Kalenteri ja asiakashallinta",
      "Hevosprofiilit ja raportit",
      "Hoitohistoria ja asiakirjat",
      "Viestintä omistajan kanssa",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Kuukaudessa · kaikki ammattimoduulit sisältyy",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Valitse Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Hätänumerot hevoselle",
    title: "Oikea apu aina käden ulottuvilla.",
    subtitle: "Hätätilanteessa jokainen sekunti on tärkeä. EquiSightin avulla sinulla on hevosesi tärkeät yhteystiedot aina välittömästi saatavilla — yksi napautus ja soitat.",
    primaryCTA: {
      label: "Aseta hätäyhteystietosi valmiiksi",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Aloita EquiSight ilmaiseksi",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Hätäyhteystiedot — soita, lähetä WhatsApp-viesti tai navigoi suoraan eläinlääkärille, klinikalle tai kaviosaepajalle",
      caption: "Yksi napautus. Ei paniikkia.",
      embeddedFrame: true,
    },
    problem: "Hevosellasi on jokin hätä — koliikit, vamma, paniikki. Ja sitten alkaa etsiminen. Ketä soitat? Onko sinulla oikea numero? Onko tämä päivystysnumero? Arvokasta aikaa menee hukkaan.",
    solution: "EquiSightin avulla kaikki on heti käsillä. Ei etsimistä. Ei epäröintiä. Yksi napautus ja olet yhteydessä.",
    scenario: {
      title: "Kuvittele — hevosesi näyttää koliikkioireita.",
      steps: [
        "Avaat EquiSightin",
        "Napautat \"Eläinlääkäri\"",
        "Soitat suoraan",
      ],
      tagline: "Ei stressiä. Ei etsimistä. Vain toimintaa.",
    },
    features: [
      "Kaikki hätänumerot yhdessä paikassa",
      "Soitto yhdellä napautuksella suoraan sovelluksesta",
      "WhatsApp-viesti yhdellä napautuksella",
      "Navigoi suoraan osoitteeseen",
      "Jokaiselle hevoselle oma yhteystietoluettelo",
      "Eläinlääkäri, klinikka, kaviosaepaja, hammashoitaja, fysioterapeutti",
      "Osoite ja reittiohjeet välittömästi saatavilla",
      "Merkitse suosikkinumerot tähdellä",
      "Hätänumerot (112, 144) aina ylimpänä",
    ],
    benefits: [
      "Rauhallisuus ja hallinta hätätilanteessa",
      "Kaikilla tallilla on samat numerot valmiina",
      "Ei enää unohdettuja käyntikortteja",
      "Reagoi sekunteja nopeammin hätätilanteessa",
    ],
    audience: "Hevosen omistajille, hoitajille, valmentajille ja talleille — kaikille, jotka ovat vastuussa hevosesta.",
    showcase: {
      eyebrow: "Valmiiksi asetettu sinulle",
      title: "13 yhteystietokategoriaa — valmiina täytettäväksi.",
      description: "Eläinlääkäristä ja päivystysklinikasta satulanvalmistajaan, ohjaajaan ja laidunhoitajaan. EquiSight tuntee maailmasi ja valmistelee oikeat yhteystietokentät puolestasi. Naputa, täytä, valmis.",
      bullets: [
        "Hätä ja terveys — eläinlääkäri, päivystys, klinikka, myrkytysneuvontapuhelin",
        "Päivittäinen hoito — kaviosaepaja, hammashoitaja, fysioterapeutti, ohjaaja",
        "Talli ja laidun — tallinpitäjä, laidunhoitaja, täysihoitotalli",
        "Rehu ja tarvikkeet — heinä-, väkirehu- ja kuiviketoimittajat",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Hätäyhteystietojen hallintanäyttö — kaikki ehdotetut yhteystiedot kategorioittain",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Hevosen hätänumeroiden tarkistuslista",
      items: [
        "Eläinlääkäri",
        "Päivystysklinikka (24/7)",
        "Eläinambulanssi · 144",
        "Kaviosaepaja",
        "Varayhteyshenkilö",
        "Yleinen hätänumero · 112",
      ],
      cta: {
        label: "Avaa EquiSightissa ja täytä heti",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Hätänumerot",
          price: "Gratis",
          note: "Aina ilmainen · kaikille, jokaisessa tilauspaketissa",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Varmista, että olet valmistautunut",
      title: "Ennen kuin se on tarpeen.",
      href: "/#waitlist",
    },
    microcopy: [
      "Ei sitoumuksia",
      "Asetettu valmiiksi 2 minuutissa",
      "Aina muokattavissa",
    ],
  },
};

export default LANDINGS;
